import { create, type StoreApi, type UseBoundStore } from 'zustand';
import { persist } from 'zustand/middleware';

interface Company {
  idCompany: number;
  tradeName: string;
  legalName: string;
  status?: string;
}

interface CompanyState {
  currentCompany: Company | null;
  setCurrentCompany: (company: Company | null) => void;
}

let useCompanyStore: UseBoundStore<StoreApi<CompanyState>>;

async function initializeStore() {

  try {
    // @ts-expect-error
    const remoteStore = await import('host/zustand/store');

    if (!remoteStore?.useCompanyStore) {
      throw new Error('No se pudo cargar useCompanyStore del host.');
    }

    useCompanyStore = remoteStore.useCompanyStore;
  } catch (error) {
    console.warn('⚠️ Fallback al store local:', error);
    useCompanyStore = create<CompanyState>()(
      persist(
        (set) => ({
          currentCompany: null,
          setCurrentCompany: (company) => set({ currentCompany: company }),
        }),
        { name: 'selected-company' }
      )
    );

  }
}


await initializeStore();

export { useCompanyStore };